var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgStar = function SvgSvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.63 7.274a1.254 1.254 0 0 0-1.172-.817h-5.073a.417.417 0 0 1-.393-.278l-1.82-5.16a1.25 1.25 0 0 0-2.342 0l-.005.013L7.01 6.179a.417.417 0 0 1-.393.278H1.542a1.25 1.25 0 0 0-.802 2.21l4.32 3.583c.132.11.183.29.129.452l-1.815 5.443a1.25 1.25 0 0 0 1.925 1.403l4.455-3.266a.417.417 0 0 1 .492 0l4.454 3.265a1.25 1.25 0 0 0 1.926-1.402l-1.815-5.446a.417.417 0 0 1 .13-.452l4.328-3.589a1.25 1.25 0 0 0 .36-1.384Z",
    fill: "currentColor"
  })));
};
export default SvgSvgStar;